import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { IntlayerProvider, MarkdownProvider, setLocaleInStorage } from 'react-intlayer'
import { ThemeProvider } from './components/theme-provider'
import { canonicalSiteUrl, localeFromPathname } from './lib/site-routing'
// Import the generated route tree
import { routeTree } from './routeTree.gen'
import './components/site-view.css'

// Explicit legacy locale URLs take precedence over a saved preference.
const requestedLocale = localeFromPathname(window.location.pathname)
if (requestedLocale) setLocaleInStorage(requestedLocale)

// Create a new router instance
const router = createRouter({ routeTree, rewrite: { input: ({ url }) => canonicalSiteUrl(url) } })

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Render the app
// biome-ignore lint/style/noNonNullAssertion: reason
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        retry: false
      }
    }
  })
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <IntlayerProvider defaultLocale='ja'>
          <ThemeProvider>
            <MarkdownProvider>
              <RouterProvider router={router} />
            </MarkdownProvider>
          </ThemeProvider>
        </IntlayerProvider>
      </QueryClientProvider>
    </StrictMode>
  )
}
